export const delay = (ms) => new Promise((res) => setTimeout(res, ms))

export default delay

// Usage:
// delay(1000)
// await delay(1000)
